// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1hoUr","cell":"ColumnAccessor_cell__2dO-t","firstCellAccent":"ColumnAccessor_firstCellAccent__1CN92"};